export interface IToulouseCounterConfig {
  name: string;
  coordinates: [number, number];
}

export const toulouseCounters: { [id: string]: IToulouseCounterConfig } = {
  '100044066': { name: 'Port St Etienne', coordinates: [1.45616, 43.59933] },
  '100058516': { name: 'Boulevard Bonrepos', coordinates: [1.4513924, 43.6130656] },
  '300015661': {
    name: 'Av. P.G Latecoere (Blagnac) - intersection rue Velasquez',
    coordinates: [1.3916, 43.6225],
  },
  '300015662': { name: 'Boulevard Yves Brunaud (Colomiers)', coordinates: [1.3545, 43.6133] },
  '300015663': {
    name: 'RM1 (Cornebarrieu) - giratoire avec RM63e',
    coordinates: [1.3403, 43.6507],
  },
  '300021473': {
    name: 'Airbus St-Martin - Giratoire de la Crabe',
    coordinates: [1.3726, 43.6112],
  },
  '300022736': { name: 'Avenue des Minimes', coordinates: [1.436936, 43.6171374] },
  '300022739': { name: 'Pont de Blagnac', coordinates: [1.3996488, 43.6247892] },
  '300022745': { name: 'Avenue Etienne Billieres', coordinates: [1.4296248, 43.5976916] },
  '300025314': { name: 'Av Camille Pujol', coordinates: [1.4592856, 43.6015616] },
  '300025316': { name: 'Rte de Saint Simon', coordinates: [1.4168806, 43.5904508] },
  '300025317': { name: 'Av Saint Exupery', coordinates: [1.4617158, 43.5872325] },
  '300025318': { name: 'Av Jean Rieux', coordinates: [1.45759, 43.59808] },
  '300025321': { name: 'Av de Grande Bretagne', coordinates: [1.4213874, 43.5972081] },
  '300045520': {
    name: 'Passerelle Robert Poujade et Digue haute Garonne',
    coordinates: [1.4340908, 43.5885032],
  },
  '300052664': { name: 'Quai de la Daurade', coordinates: [1.4405287, 43.5997462] },
  '300052670': { name: 'Quai de Tounis', coordinates: [1.4405176, 43.599272] },
  '300052687': { name: 'Rue de Metz', coordinates: [1.441962, 43.6000385] },
  '300052735': { name: 'Avenue Jean Monnet', coordinates: [1.3407106, 43.6178321] },
};
